import { useState, useEffect } from "react";
import { updateFocusComponents } from "../../../shared/utils/updateFocusComponents";

export const useFocus = (loadingConservante, loadingMaterial, contratoLicitacao) => {
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    if (!loadingConservante && !loadingMaterial && focus) {
      updateFocusComponents({
        tagNameElementHTML: "input",
        numberInitialElementsIgnored: contratoLicitacao ? 1 : 2,
        delay: 50
      });
      setFocus(false);
    }
  }, [loadingConservante, loadingMaterial, contratoLicitacao, focus]);

  return {
    setFocus: setFocus
  };
};
